export enum AccountsMessages {
  update = 'Account was updated',
}
